import axios from 'axios';
import { apiClient } from './endpoints';
import { exportTypeEnum } from '../../utils/enums';

export interface ExportResponse {
    message: string;
}

export interface DownloadCsvQueries {
    startDate: string;
    endDate: string;
    delimiter?: string;
    fileName?: string;
}

export const downloadCsv = async (exportType: number, queries: DownloadCsvQueries): Promise<void> => {
    try {
        const response = await apiClient.get<Blob>(`/download/${exportType}`, {
            responseType: 'blob',
            params: queries,
        });

        const contentDisposition = response.headers['content-disposition'];
        const fileNameMatch = contentDisposition?.match(/filename="(.+)"/);
        const fileName = fileNameMatch ? fileNameMatch[1] : 'export.csv';

        const blob = new Blob([response.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
